<style scoped>

  .content {
    padding: 5px 20px 20px 20px !important;
  }

</style>

<template>

  <div class="ui fluid styled accordion">

    <div id="filters-button" class="title" :class="{ active }">
      <i class="dropdown icon"></i>
      Filtros
    </div>

    <div class="content" :class="{ active }">

      <form class="ui form" :class="{ loading }" @submit.prevent="onSearch()">
        <div class="fields">
          <div class="three wide field">
            <label class="form-label">Data Inicial</label>
            <div id="start-date" class="ui calendar">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input class="date">
              </div>
            </div>
          </div>
          <div class="three wide field">
            <label class="form-label">Data Final</label>
            <div id="end-date" class="ui calendar">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input class="date">
              </div>
            </div>
          </div>
          <div class="six wide field">
            <label class="form-label">Cliente</label>
            <input type="text" placeholder="Código, CNPJ ou Razão Social" v-model="filter.customerKeyWord">
          </div>          
          <div class="four wide field">
            <label class="form-label">Status</label>
            <select id="select-status" class="ui fluid search dropdown form-dropdown" v-model="filter.status">
              <option value="*"><i class="asterisk grey text icon"></i> Todos</option>
              <option v-for="s in status" :value="s.id">
                <i class="icon" :class="s.icon + ' ' + s.color"></i> {{ s.description }}
              </option>              
            </select>
          </div>
        </div>
        <div v-if="!$isSeller()" class="fields">          
          <div class="five wide field">
            <label class="form-label">Responsável</label>
            <select id="select-owner" class="ui fluid search dropdown form-dropdown" v-model="filter.ownerId">
              <option value="*">Todos</option>
              <option v-for="user in $store.state.quotationsUsers" :value="user.id">{{ user.value }}</option>
            </select>
          </div>
          <div class="six wide field">
            <label class="form-label">Representante</label>
            <select id="select-seller" class="ui fluid search dropdown form-dropdown" v-model="filter.sellerId">
              <option value="*">Todos</option>
              <option v-for="seller in $store.state.quotationsSellers" :value="seller.id">{{ seller.value }}</option>
            </select>
          </div>  
          <div class="five wide field">
            <label class="form-label">Gerente</label>
            <select id="select-manager" class="ui fluid search dropdown form-dropdown" v-model="filter.managerId">
              <option value="*">Todos</option>
              <option v-for="manager in $store.state.quotationsManagers" :value="manager.id">{{ manager.value }}</option>
            </select>
          </div>        
        </div>
        <div class="fields">          
          <div class="three wide field">
            <label class="form-label">Orçamento</label>
            <input type="text" v-model="filter.quotationId" maxlength="6">
          </div>
          <div class="three wide field">
            <label class="form-label">Pedido</label>
            <input type="text" v-model="filter.salesOrderId" maxlength="6">
          </div>
          <div class="three wide field">
            <label class="form-label">Nota Fiscal</label>
            <input type="text" v-model="filter.invoiceId" maxlength="15">
          </div>                  
          <div v-if="$isApprover()" class="seven wide field">
            <label class="form-label">Aprovação</label>
            <select id="select-approval" class="ui fluid search dropdown form-dropdown" v-model="filter.approval">
              <option value="*">Todos</option>
              <option value="1">Orçamentos que estou aprovando</option>
              <option value="2">Aguardando aprovação dentro da minha alçada</option>
            </select>
          </div>
        </div>
        <button class="ui basic blue icon button" type="submit" style="margin-top: 10px;">
          <i class="search icon"></i>
          Pesquisar
        </button>
      </form>

    </div>

  </div>

</template>

<script>

  import { Calendar, moment } from "@/utils"
  import QuotationService from "@/services/quotation-service"

  export default {

    data() {
      return {
        loading: true,
        status: [],     
        filter: {
          startDate: null,
          endDate: null,
          customerKeyWord: "",
          status: "*",
          ownerId: "*",
          sellerId: "*",
          managerId: "*",
          quotationId: "",
          salesOrderId: "",
          invoiceId: "",
          approval: "*",          
        },        
      }
    },

    props: ["active", "searching"],

    created() {

      for (let [key, value] of Object.entries(QuotationService.QUOTATION_STATUS)) {
        if (key != "0") {
          this.status.push({
            id: key,
            ...value,
          })
        }
      }
    },

    mounted() {

      $(".accordion").accordion()

      Calendar.initInputs()           

      $(".form-dropdown").dropdown({
        fullTextSearch: true,
      })

      this.loadData()
    },

    methods: {

      async loadData() {

        this.loading = true

        try {

          if (!this.$isSeller()) {

            if (this.$store.state.quotationsUsers.length == 0)
              this.$store.commit("setQuotationsUsers", await QuotationService.getEntityList("user"))
            
            if (this.$store.state.quotationsSellers.length == 0)
              this.$store.commit("setQuotationsSellers", await QuotationService.getEntityList("seller"))
            
            if (this.$store.state.quotationsManagers.length == 0)
              this.$store.commit("setQuotationsManagers", await QuotationService.getEntityList("manager"))
          }

          this.updateFilters()

          this.loading = false
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      updateFilters() {

        let startDate = null
        let endDate = null

        if (this.$store.state.quotationsFilter) {    
          startDate = this.$store.state.quotationsFilter.startDate
          endDate = this.$store.state.quotationsFilter.endDate  
          this.filter = this.$cloneObject(this.$store.state.quotationsFilter)
        }  

        $("#start-date").calendar("set date", moment(startDate).toDate())
        $("#end-date").calendar("set date", moment(endDate).toDate())  

        $("#select-status").dropdown("set selected", this.filter.status) 

        if (!this.$isSeller()) {
          $("#select-owner").dropdown("set selected", this.filter.ownerId)
          $("#select-seller").dropdown("set selected", this.filter.sellerId)
          $("#select-manager").dropdown("set selected", this.filter.managerId)          
        }          

        if (this.$isApprover())
          $("#select-approval").dropdown("set selected", this.filter.approval)          
      },

      onSearch() {

        this.filter.startDate = $("#start-date").calendar("get date")
        this.filter.endDate = $("#end-date").calendar("get date")        

        let data = this.$cloneObject(this.filter)

        this.$store.commit("setQuotationsFilter", data)

        if (data.status == "*") data.status = ""
        if (data.ownerId == "*") data.ownerId = ""
        if (data.sellerId == "*") data.sellerId = ""
        if (data.managerId == "*") data.managerId = ""
        if (data.approval == "*") data.approval = ""

        this.$emit("onSearch", data)
      },

      toggleActive() {
        $("#filters-button").click()
      },
    }
  }

</script>
